import { ChangeEvent, useEffect, useState } from 'react';
import { RefCallBack } from 'react-hook-form';
import { IconButton, TextField, TextFieldProps, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Eye } from 'ts-react-feather-icons';

import FormInputErrorMessage from './form-input-error-message';

type Props = Omit<TextFieldProps, 'variant'> & {
  label?: string;
  errorMessage?: string;
  ref?: RefCallBack;
  value?: string | null;
  onChange: (value: string) => void;
};

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    maxWidth: '100%',
    marginTop: '10px',
  },
  iconButton: {
    padding: '6px',
  },
}));

const FormSsnField = ({ label, errorMessage, onChange, value, ...other }: Props) => {
  const classes = useStyles();
  const [maskedSsn, setMaskedSsn] = useState('');
  const [showUnmaskedSsn, setShowUnmaskedSsn] = useState(false);

  useEffect(() => {
    if (value) {
      setMaskedSsn(value.replace(/./g, '*'));
    }
  }, [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const currentValue = event.target.value;
    let prevValue = value || '';

    if (currentValue.length > prevValue.length) {
      const newChar = currentValue.slice(-1);
      onChange(`${prevValue}${newChar}`);
    } else {
      const charsRemovedCount = prevValue.length - currentValue.length;
      onChange(prevValue.slice(0, -charsRemovedCount));
    }

    setMaskedSsn(currentValue.replace(/./g, '*'));
  };

  return (
    <div className={classes.input}>
      {label && <Typography variant="caption">{label}</Typography>}
      <TextField
        error={!!errorMessage}
        inputProps={{
          style: {
            height: '30px',
            paddingRight: '40px',
            padding: '1vh 2vh',
          },
        }}
        fullWidth
        variant="outlined"
        onChange={handleChange}
        value={showUnmaskedSsn ? value : maskedSsn}
        InputProps={{
          endAdornment: (
            <IconButton
              className={classes.iconButton}
              onClick={() => setShowUnmaskedSsn((val) => !val)}
              size="large"
            >
              <Eye />
            </IconButton>
          ),
        }}
        {...other}
      />
      {errorMessage && <FormInputErrorMessage error={errorMessage} />}
    </div>
  );
};

export default FormSsnField;
